<script setup>
/**
 * @fileoverview Parts list for the current sheet: tile counts per
 * (size, color).
 *
 * @component
 */
import { computed } from 'vue';
import { useMosaicStore } from '../stores/mosaicStore';
import { formatSize } from '../utils/patternData.js';

const store = useMosaicStore();

const total = computed(() => store.partsList.reduce((sum, r) => sum + r.count, 0));
</script>

<template>
    <div v-if="store.selectedPattern" class="flex flex-col gap-2">
        <table class="w-full text-xs text-left">
            <caption class="sr-only">
                Tiles per sheet by size and color
            </caption>
            <thead>
                <tr class="text-dryline border-b border-engobe">
                    <th scope="col" class="py-1 font-medium">Size</th>
                    <th scope="col" class="py-1 font-medium">Color</th>
                    <th scope="col" class="py-1 font-medium text-right">Per sheet</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="row in store.partsList"
                    :key="`${row.size}|${row.colorName}`"
                    class="border-b border-engobe-200"
                >
                    <td class="py-1">{{ formatSize(row.size) }}</td>
                    <td class="py-1">
                        <span class="inline-flex items-center gap-1.5">
                            <span
                                class="inline-block w-3 h-3 border border-engobe"
                                :style="{ backgroundColor: row.hex || '#ffffff' }"
                                aria-hidden="true"
                            />
                            <span :class="row.hex ? 'text-black' : 'text-dryline italic'">
                                {{ row.colorName }}
                            </span>
                        </span>
                    </td>
                    <td class="py-1 text-right">{{ row.count }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr class="font-medium">
                    <td class="py-1" colspan="2">Total</td>
                    <td class="py-1 text-right">{{ total }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
